import { render, staticRenderFns } from "./noData.vue?vue&type=template&id=b13ef6ee&scoped=true"
import script from "./noData.vue?vue&type=script&lang=js"
export * from "./noData.vue?vue&type=script&lang=js"
import style0 from "./noData.vue?vue&type=style&index=0&id=b13ef6ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13ef6ee",
  null
  
)

export default component.exports